import { BlocklistRulesModule } from '@nirvana/shared/dtos/types/policies/common';
import { BlocklistRulesSearchableKeywords } from './blocklist-rules.types';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';

export function getBlocklistRulesDefaultValue(): BlocklistRulesModule {
  return {
    enabled: true,
    categories: {
      applicationHash: true,
      dllFiles: false,
      scriptFiles: false,
      applicationPath: false,
      networkConnection: false,
    }
  };
}

// searchable keywords
export function getBlocklistRulesSearchableKeywords(): {
  [type in BlocklistRulesSearchableKeywords]: SearchableKeyword;
} {
  return {
    [BlocklistRulesSearchableKeywords.BlocklistRules]: {
      translatedLabel: translateFn('Blocklist'),
      label: 'Blocklist',
    },
    [BlocklistRulesSearchableKeywords.ApplicationHash]: {
      translatedLabel: translateFn('Application hash'),
      label: 'Application hash',
    },
    [BlocklistRulesSearchableKeywords.DllFiles]: {
      translatedLabel: translateFn('DLL files'),
      label: 'DLL files',
    },
    [BlocklistRulesSearchableKeywords.ScriptFiles]: {
      translatedLabel: translateFn('Script files'),
      label: 'Script files',
    },
    [BlocklistRulesSearchableKeywords.ApplicationPath]: {
      translatedLabel: translateFn('Application path'),
      label: 'Application path',
    },
    [BlocklistRulesSearchableKeywords.NetworkConnection]: {
      translatedLabel: translateFn('Network connection'),
      label: 'Network connection',
    },
  };
}
